'use client'

import cls from './home-landing.module.css'
import type { ReactNode } from 'react'
import { useEffect, useRef, useState } from 'react'

type HomeScrollRevealProps = {
    children: ReactNode
    className?: string
    staggerIndex?: number
}

export default function HomeScrollReveal({ children, className, staggerIndex }: HomeScrollRevealProps) {
    const ref = useRef<HTMLDivElement>(null)
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const el = ref.current
        if (!el) {
            return
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry?.isIntersecting) {
                    setVisible(true)
                    observer.disconnect()
                }
            },
            { threshold: 0.09, rootMargin: '0px 0px -8% 0px' }
        )

        observer.observe(el)

        return () => observer.disconnect()
    }, [])

    const delayMs = staggerIndex !== undefined ? staggerIndex * 75 : 0

    return (
        <div
            ref={ref}
            className={`${cls.reveal} ${visible ? cls.revealVisible : ''} ${className ?? ''}`}
            style={delayMs ? { transitionDelay: `${delayMs}ms` } : undefined}>
            {children}
        </div>
    )
}
